module.exports = __webpack_public_path__ + "static/img/hoverlogo10.4a71c7e4.png";